module.exports = __webpack_public_path__ + "img/pause-circle.26764024.svg";